'use client';
import React, { useState } from 'react';
import { Clipboard, Check } from 'lucide-react';
import { create } from "apisauce";

export default function App() {
  const api = create({
    baseURL: "https://api.openai.com/",
    timeout: 60 * 1000,
    headers: {
      'Content-Type': 'application/json', 
      'Authorization': 'Bearer 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',
      'OpenAI-Organization': 'org-lUq5W4rCMM7FTnzZw925Svx9',
      'OpenAI-Project': 'proj_uAb1YzWyWVl9enoNjJnBt3zP',
    },
  });

  const [idea, setIdea] = useState('');
  const [tone, setTone] = useState('');
  const [totalVariant, setTotalVariant] = useState('');
  const [hookType, setHookType] = useState('');
  const [hooks, setHooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(null);

  const generateHooks = async () => {
    console.log("hehehehe")
    setLoading(true);
    setHooks([]);
    // setTimeout(() => {
    //   setHooks([
    //     'Niatnya cuma pengen sehat, eh malah bingung mulai dari mana...',
    //     'Udah langganan gym, tapi masih aja ngerasa nggak ada hasil?',
    //     'Pengen olahraga rutin, tapi selalu kalah sama rasa mager?',
    //     'Ngerasa makin capek setelah olahraga? Bisa jadi kamu salah caranya.',
    //     'Badan pegel, tidur nggak nyenyak, makan berantakan... mungkin kamu butuh workout, bukan kopi.',
    //   ]);
    //   setLoading(false);
    // }, 2000);

    try {
      const res = await api.post("v1/responses", {
        "model": "gpt-4.1",
        "input": `Buatkan ${totalVariant} contoh hook untuk konten IG reels. Berikan hook nya langsung dan pastikan hasilnya dalam bentuk bullet points. Tone nya ${tone}, tipe hooknya ${hookType} dan topiknya adalah ${idea}. Awali setiap hook dengan lambang '+'.`
      })
      let hooksRaw = (res.data?.output[0]?.content[0]?.text);
      let hooksRawList = hooksRaw.split("+")
      let hooksCleanList = [];

      let startIndex = 0;
      if (hooksRawList > totalVariant) {
        startIndex = 1;
      }
      
      for (let i = startIndex; i < hooksRawList.length; i++) {
        if (hooksRawList[i].trim()) {
          console.log(hooksRawList[i]);
          hooksCleanList.push(hooksRawList[i]);
        }
      }
      setTimeout(() => {
        console.log(hooksCleanList);
        setHooks(hooksCleanList);
        setLoading(false);
      }, 5000);

    } catch (e) {
      console.error(e);
    }
  };

  const copyHook = async (text, index) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 1200);
    } catch (err) {
      console.error('Clipboard error', err);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center p-6">
      <div className="w-full max-w-xl rounded-2xl border border-white/15 bg-white/10 backdrop-blur-md shadow-2xl p-8">
        {/* header */}
        <header className="mb-8">
          <h1 className="py-1 text-2xl md:text-3xl font-bold bg-gradient-to-r from-[#B7A3FF] via-[#A78BFA] to-[#8B5CF6] bg-clip-text text-transparent">
            AI-Powered Hook Generator
          </h1>
          <p className="text-xs text-gray-300 mt-1">
            Presents by AI Creator Labs <span className="font-semibold">(Open BETA)</span>
          </p>
        </header>

        {/* TOPIK */}
        <div className="mb-4">
          <label className="block text-xs font-semibold uppercase mb-1 tracking-wide">
            Topik Konten
          </label>
          <textarea
            className="w-full rounded-md border border-white/20 bg-white/10 backdrop-blur-sm p-3 text-sm text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-400"
            rows={4}
            placeholder="Masukkan isi konten…"
            value={idea}
            onChange={(e) => setIdea(e.target.value)}
          />
        </div>

        {/* GAYA */}
        <div className="mb-4">
          <label className="block text-xs font-semibold uppercase mb-1 tracking-wide">
            Gaya Penulisan
          </label>
          <select
            className="w-full rounded-md border border-white/20 bg-white/10 backdrop-blur-sm p-3 text-sm text-white focus:outline-none focus:ring-indigo-400"
            value={tone}
            onChange={(e) => setTone(e.target.value)}
          >
            <option value="">Pilih gaya…</option>
            {['Formal', 'Santai', 'Sehari-hari', 'Lucu', 'Marah-marah'].map((g) => (
              <option key={g}>{g}</option>
            ))}
          </select>
        </div>

        {/* JUMLAH + TIPE */}
        <div className="mb-6 grid grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-semibold uppercase mb-1 tracking-wide">
              Jumlah Hook
            </label>
            <select
              className="w-full rounded-md border border-white/20 bg-white/10 backdrop-blur-sm p-3 text-sm text-white focus:outline-none focus:ring-indigo-400"
              value={totalVariant}
              onChange={(e) => setTotalVariant(e.target.value)}
            >
              <option value="">Jumlah…</option>
              {[5, 10, 15, 20, 25].map((n) => (
                <option key={n}>{n}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase mb-1 tracking-wide">
              Tipe Hook
            </label>
            <select
              className="w-full rounded-md border border-white/20 bg-white/10 backdrop-blur-sm p-3 text-sm text-white focus:outline-none focus:ring-indigo-400"
              value={hookType}
              onChange={(e) => setHookType(e.target.value)}
            >
              <option value="">Tipe…</option>
              <option value="question">Question</option>
              <option value="fact">Fact</option>
              <option value="story">Story</option>
              <option value="problem">Problem-Based</option>
              <option value="dream">Dream-Outcome</option>
            </select>
          </div>
        </div>

        {/* GENERATE */}
        <div
          className={`mt-0 md:mt-2 translate-y-[20%] animate-fade-in-up-0`}
        >
          <button
            onClick={generateHooks}
            disabled={loading}
            className="relative rounded-1xl font-bold transition-[transform] ease-in-out duration-[400ms] hover:-translate-y-[5px] items-center justify-center w-full py-3 rounded-md bg-[radial-gradient(at_top_left,_#A78BFA50_20%,_#00000000_100%)] overflow-hidden text-white font-bold focus:outline-none glow-sweep"
          >
            Generate ✨
          </button>
        </div>

        {loading && <p className="mt-3 text-xs italic text-gray-400">Generating hooks…</p>}

        {/* LIST */}
        {hooks.length > 0 && (
          <div className="mt-8">
            <p className="font-semibold mb-3">
              🏋️‍♀️ {hooks.length} Hooks (Tipe Hook: {hookType}, Gaya: {tone}, Topik: {idea})
            </p>
            <ul className="space-y-2 max-h-60 overflow-y-auto pr-1">
              {hooks.map((h, i) => (
                <li
                  key={i}
                  className="flex items-start gap-2 border border-white/15 bg-white/5 p-3 rounded-lg hover:bg-white/10 transition"
                >
                  <span className="text-sm leading-snug flex-1">{h}</span>
                  <button
                    onClick={() => copyHook(h, i)}
                    title="Copy"
                    className="text-gray-300 hover:text-white"
                  >
                    {copiedIndex === i ? (
                      <Check className="h-4 w-4 text-emerald-400 transition-transform duration-150 scale-110" />
                    ) : (
                      <Clipboard className="h-4 w-4" />
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}